var SHARED_Z_INDEX = 0;

export { SHARED_Z_INDEX };
